import { createContext, useContext } from "react";
import { isNil } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolbarContext = /*#__PURE__*/createContext(null);
export function useToolbarContext() {
  const context = useContext(ToolbarContext);

  if (!isNil(context)) {
    return [context, true];
  }

  return [{}, false];
}
export function useToolbarProps() {
  return useToolbarContext();
}
export function ClearToolbar({
  children
}) {
  return /*#__PURE__*/_jsx(ToolbarContext.Provider, {
    value: null,
    children: children
  });
}